import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Nonacbusforcollegepicnicpune() {



const cardData =
{
  keyword: 'Non AC Bus for College Picnic Pune',
  heading: 'Sanavi Travels: Non AC Bus for College Picnic Pune',
  headingDescription: 'Sanavi Travels provides safe, reliable, and budget-friendly Non AC Bus for College Picnic Pune, specially designed for colleges, educational institutes, student groups, and youth organizations planning affordable and well-managed picnic and local tour travel from Pune.',

  top: 'Popular College Picnic & Student Travel Experiences with Non AC Bus from Pune',

  topPlaces: [
    {
      title: 'College Picnic Day Trips from Pune',
      description: 'College picnics are an important part of student life, offering relaxation, bonding, and a break from academics. Non AC buses are the most preferred option for college picnic trips from Pune due to their affordability, spacious seating, and suitability for short-distance travel. Traveling together in a single bus allows students to enjoy music, conversations, and group activities throughout the journey. Colleges can easily manage attendance, discipline, and scheduling when all students travel together. Non AC buses also allow easy boarding and deboarding at picnic spots, making the entire trip smooth and well-coordinated.'
    },
    {
      title: 'Sinhagad, Lonavala & Local Hill Spots',
      description: 'Popular picnic destinations such as Sinhagad Fort, Lonavala, Karla Caves, Bhaja Caves, and nearby hill areas are ideal for college groups. Non AC buses are perfectly suited for these short hill journeys, especially during pleasant weather. Students can enjoy fresh air, scenic views, and open windows while traveling, enhancing the picnic experience. Bus travel eliminates parking issues and traffic stress near crowded tourist locations.'
    },
    {
      title: 'Student Group Travel & Bonding',
      description: 'College picnics are about creating memories and strengthening friendships. Traveling by non AC bus keeps the entire group together, encouraging interaction, fun, and unity. Unlike multiple vehicles, a single bus ensures no student is left behind, and the journey itself becomes part of the picnic experience.'
    },
    {
      title: 'Budget-Friendly Educational Tours',
      description: 'Educational institutes often plan trips within limited budgets. Non AC buses help colleges control transportation costs while still providing safe and reliable travel. This makes it possible to organize frequent educational tours, industrial visits, and local sightseeing trips without financial strain.'
    },
    {
      title: 'Safe Travel for Students',
      description: 'Safety is the top priority for college management and parents. Non AC buses used for student picnics are driven by experienced drivers who follow disciplined driving practices. Group travel by bus ensures controlled movement, easier supervision, and safer journeys compared to individual vehicles.'
    },
    {
      title: 'Local Sightseeing & Nature Visits',
      description: 'Non AC buses are ideal for local sightseeing trips around Pune, including dams, gardens, lakes, and nature parks. Students can enjoy open-air travel, photography, and group fun during these short-distance journeys.'
    },
    {
      title: 'One-Day College Picnic Tours',
      description: 'Most college picnics are one-day events. Non AC buses offer flexible timing, allowing early morning departures and comfortable return trips by evening. Colleges can plan strict schedules without worrying about vehicle availability.'
    },
    {
      title: 'Large Student Groups',
      description: 'Handling large student groups is easier with 32 seater or 35 seater non AC buses. Entire classes or batches can travel together, making attendance tracking and coordination simple for teachers and organizers.'
    },
    {
      title: 'Stress-Free Faculty & Organizer Experience',
      description: 'When transportation is handled professionally, faculty members and picnic organizers can focus on student safety and enjoyment rather than travel logistics. Non AC bus hire removes the burden of route planning, driving, and traffic management.'
    },
    {
      title: 'Eco-Friendly Group Travel',
      description: 'Using a single bus instead of multiple vehicles reduces fuel consumption and traffic congestion. This makes non AC bus travel a more environmentally responsible option for college outings.'
    }
  ],

  services: [
    {
      name: 'Non AC Bus for College Picnic Pune',
      description: 'Sanavi Travels specializes in providing Non AC Bus for College Picnic Pune, ensuring affordable, safe, and well-organized student travel. Our buses are spacious, regularly maintained, and suitable for short-distance picnic and local tour routes. Professional drivers ensure disciplined driving, punctual pickups, and smooth coordination, making college picnic transport completely stress-free for students and faculty.'
    },
    {
      name: 'Non AC Bus Rental College Picnic Pune',
      description: 'Non AC bus rental services for college picnics are designed to support educational institutes with budget-conscious yet dependable transportation. These buses are ideal for day trips, local sightseeing, and nearby picnic spots, offering ample seating and easy movement for student groups.'
    },
    {
      name: 'Mini Bus on Rent College Picnic Pune',
      description: 'Mini non AC buses are suitable for small student groups, cultural teams, and departmental picnics. They provide flexibility, easy maneuvering, and cost-effective travel for compact college outings.'
    },
    {
      name: '32 Seater Non AC Bus College Picnic Pune',
      description: '32 seater non AC buses are perfect for medium-sized college groups, allowing entire classes or divisions to travel together comfortably. These buses balance seating capacity, comfort, and affordability for student picnics.'
    },
    {
      name: '35 Seater Non AC Bus College Picnic Pune',
      description: '35 seater non AC buses are ideal for large college batches and inter-college picnic groups. Traveling in one large vehicle simplifies coordination, attendance management, and ensures a unified group experience.'
    },
    {
      name: 'Affordable Non AC Bus Hire Pune',
      description: 'Affordable non AC bus hire options help colleges organize picnics without exceeding budgets. Transparent pricing and value-for-money packages make it easier for institutes to plan frequent student trips.'
    },
    {
      name: 'Best Non AC Bus Service College Picnic Pune',
      description: 'Sanavi Travels is recognized for delivering dependable non AC bus services for college picnics, focusing on safety, punctuality, and student-friendly travel management.'
    },
    {
      name: 'Non AC Bus with Driver College Picnic Pune',
      description: 'All non AC bus rentals include experienced drivers who understand student travel requirements, picnic routes, and local road conditions, ensuring safe and smooth journeys.'
    },
    {
      name: 'Non AC Bus for Student Picnic Pune',
      description: 'Student picnic bus services are designed to support fun, discipline, and safety. Spacious interiors allow students to relax, interact, and enjoy the journey as part of the picnic experience.'
    },
    {
      name: 'Non AC Bus for Local Tour College Picnic Pune',
      description: 'For local tours and sightseeing around Pune, non AC buses provide the perfect balance of comfort and economy, making them ideal for short educational and recreational trips.'
    },
    {
      name: 'Non AC Bus for Group College Picnic Pune',
      description: 'Group-focused non AC bus services ensure that all students travel together, reducing the risk of miscommunication, delays, or safety concerns during college picnics.'
    },
    {
      name: 'Non AC Bus for Sightseeing College Picnic Pune',
      description: 'Sightseeing trips become more enjoyable when students can travel together in a single bus, enjoy open-air movement, and focus on exploration rather than transportation hassles.'
    },
    {
      name: 'Non AC Bus for Family & Combined College Events',
      description: 'Some college events include parents or mixed groups. Non AC buses comfortably accommodate such combined groups while keeping travel costs under control.'
    },
    {
      name: 'Non AC Bus for Corporate & Sponsored College Events',
      description: 'Colleges organizing sponsored events, fests, or corporate-supported picnics can rely on non AC buses for economical and professional group transport.'
    },
    {
      name: 'Non AC Bus for Student Safety & Discipline',
      description: 'Traveling in a single non AC bus allows better supervision, attendance tracking, and discipline control, ensuring student safety throughout the picnic journey.'
    }
  ],

  tableData: [
    ['Non AC College Picnic Bus', 'Mini Bus'],
    ['32 Seater Bus', '35 Seater Bus'],
    ['Student Picnic Travel', 'Local Sightseeing'],
    ['Affordable Transport', 'Group Travel'],
    ['One-Day Picnic', 'Educational Tours']
  ],

  whychoose: [
    { WhyChooseheading: 'Student-Safe Travel', WhyChoosedescription: 'Designed specifically for student and college group safety.' },
    { WhyChooseheading: 'Affordable Pricing', WhyChoosedescription: 'Budget-friendly options for educational institutes.' },
    { WhyChooseheading: 'Experienced Drivers', WhyChoosedescription: 'Drivers trained for student group handling.' },
    { WhyChooseheading: 'Group Coordination', WhyChoosedescription: 'Entire batch travels together in one vehicle.' },
    { WhyChooseheading: 'Well-Maintained Buses', WhyChoosedescription: 'Clean, serviced, and reliable vehicles.' },
    { WhyChooseheading: 'Flexible Scheduling', WhyChoosedescription: 'Supports early departures and late returns.' },
    { WhyChooseheading: 'Easy Supervision', WhyChoosedescription: 'Simplifies attendance and discipline management.' },
    { WhyChooseheading: 'Trusted College Transport Partner', WhyChoosedescription: 'Sanavi Travels is known for student travel services.' }
  ]
};

const faqData = [
  { question: 'Do you provide non AC buses for college picnics in Pune?', answer: 'Yes, Sanavi Travels offers non AC bus services for college picnics in Pune.' },
  { question: 'Are these buses suitable for students?', answer: 'Yes, they are safe, spacious, and ideal for student travel.' },
  { question: 'Do buses come with drivers?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'Are 32 and 35 seater buses available?', answer: 'Yes, multiple seating options are available.' },
  { question: 'Is this service budget-friendly?', answer: 'Yes, non AC buses are the most economical option.' },
  { question: 'Can we plan one-day picnic trips?', answer: 'Yes, one-day college picnic trips are fully supported.' },
  { question: 'Are buses cleaned before trips?', answer: 'Yes, buses are cleaned and checked before departure.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup and drop locations can be customized.' },
  { question: 'Is this suitable for large student groups?', answer: 'Yes, large batches can travel together.' },
  { question: 'How do we book a non AC bus for college picnic?', answer: 'You can book through our website or customer support.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Prof. Anil Deshmukh',
    feedback: 'Excellent non AC bus service for our college picnic. Safe, punctual, and very affordable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Student Committee',
    feedback: 'The bus was clean and comfortable. Entire batch traveled together without any issues.',
    rating: 5
  }
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Bus for College Picnic Pune - Sanavi Travels",
  "description": "Sanavi Travels provides Non-AC buses for college picnics in Pune. Options include 32-seater and 35-seater buses, mini buses, and Non-AC buses for family trips, group outings, corporate events, weddings, sightseeing, local tours, and student picnics with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Non AC Bus for College Picnic Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Non-AC buses for college picnics in Pune with Sanavi Travels. 32-seater, 35-seater, and mini bus options for student trips, family outings, corporate events, weddings, sightseeing, and local tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/290.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Nonacbusforcollegepicnicpune;